module.exports={
    "name": "dao",
    "comment": "DAO rescue hardfork",
    "eip": {
        "url": "https://eips.ethereum.org/EIPS/eip-779",
        "status": "Final"
    },
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {},
    "casper": {},
    "sharding": {}
}
